






























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import EmptyPreviewImage from "./ImageGallery/emptyPreviewImage.vue";

// Enums/Data
import { BASE_URL } from "@/store/modules/api";

// Types
import { IGalleryImageType } from "@/models/images";

@Component({
  components: {
    "empty-image": EmptyPreviewImage
  }
})
export default class ImageGallery extends Vue {
  @Prop({ required: true })
  public images!: IGalleryImageType[];

  @Prop({ default: false })
  public isLoading!: boolean;

  public activeImage = {} as IGalleryImageType;

  public setActiveImage(image = {} as IGalleryImageType) {
    if (!this.$_.isEmpty(image)) {
      this.activeImage = image;
      return;
    }

    if (!this.$_.isEmpty(this.defaultImage)) {
      this.activeImage = this.defaultImage;
      return;
    }

    this.activeImage = this.$_.get(
      this.$_.filter(this.images, ["exists", true]),
      "[0]",
      {}
    );
  }

  public isFirstBehind(imageIndex) {
    if (imageIndex === this.activeImageIndex) {
      return false;
    }

    if (this.activeImageIndex === 0 && imageIndex + 1 === this.images.length) {
      return true;
    }

    if (imageIndex === this.activeImageIndex - 1) {
      return true;
    }

    return false;
  }

  public isSecondBehind(imageIndex) {
    if (imageIndex === this.activeImageIndex) {
      return false;
    }

    if (
      this.activeImageIndex === 0 &&
      imageIndex + 1 === this.images.length - 1
    ) {
      return true;
    }

    if (this.activeImageIndex === 1 && imageIndex + 1 === this.images.length) {
      return true;
    }

    if (imageIndex === this.activeImageIndex - 2) {
      return true;
    }

    return false;
  }

  public get defaultImage() {
    const image = this.$_.find(this.images, ["default", true]);
    return image ? image : ({} as IGalleryImageType);
  }

  public get activeImageIndex() {
    return this.$_.findIndex(this.images, [
      "id",
      this.$_.get(this.activeImage, "id", "")
    ]);
  }

  private getSrc(image) {
    return `url(${BASE_URL}api/images/${image.hash}/download?size=400x400)`;
  }

  public next() {
    const newIndex =
      this.activeImageIndex === this.images.length - 1
        ? 0
        : this.activeImageIndex + 1;
    this.activeImage = this.images[newIndex];
  }

  @Watch("images", { immediate: true })
  public onImagesChange() {
    if (this.activeImageIndex === -1) {
      this.setActiveImage();
    }
  }
}
